"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductPackagingPriceByWeight = exports.getProductPackagingMinimalWeight = exports.getProductPackagingWeight = void 0;
var BoxPrices_1 = require("./BoxPrices");
var Formatting_1 = require("../../Formatting");
var getProductPackagingWeight = function (_a, _b) {
    var productPackaging = _a.productPackaging;
    var _c = _b === void 0 ? {} : _b, _d = _c.format, format = _d === void 0 ? 'short' : _d;
    if (!productPackaging)
        return '';
    var article = productPackaging.article, quantity = productPackaging.quantity, label = productPackaging.label, displayOnlyName = productPackaging.displayOnlyName, unit = productPackaging.unit, isEstimate = productPackaging.isEstimate, value = productPackaging.value;
    var text = '';
    if (format === 'long' || displayOnlyName) {
        if (format === 'long' && article)
            text += (0, Formatting_1.capitalize)(article);
        if (quantity)
            text += " ".concat(quantity > 1 ? quantity : format !== 'long' ? article : '');
        text += " ".concat(label);
    }
    if (!displayOnlyName) {
        var unitText = unit.includes('pièce') ? " ".concat(value * quantity > 1 ? unit + 's' : unit) : unit;
        if (quantity > 1 && format !== 'long')
            text += " ".concat(quantity, "&nbsp;x&nbsp;");
        text += "".concat(format === 'long' ? ' de ' : '').concat(value).concat(unitText);
    }
    if (isEstimate)
        text += format !== 'long' ? ' min.' : ' minimum';
    return text;
};
exports.getProductPackagingWeight = getProductPackagingWeight;
var getProductPackagingMinimalWeight = function (_a) {
    var productPackaging = _a.productPackaging;
    if (!productPackaging)
        return '';
    var unit = productPackaging.unit.includes('pièce')
        ? " ".concat(productPackaging.value > 1 ? productPackaging.unit + 's' : productPackaging.unit)
        : productPackaging.unit;
    var text = "".concat(productPackaging.value).concat(unit);
    if (productPackaging.isEstimate)
        text += ' min.';
    return text;
};
exports.getProductPackagingMinimalWeight = getProductPackagingMinimalWeight;
var getProductPackagingPriceByWeight = function (_a, priceCategory) {
    var productPackaging = _a.productPackaging;
    if (!(productPackaging === null || productPackaging === void 0 ? void 0 : productPackaging.price) || !priceCategory || !(productPackaging === null || productPackaging === void 0 ? void 0 : productPackaging.masterUnit))
        return '';
    var price = (0, BoxPrices_1.getBoxPrice)(productPackaging, priceCategory);
    return "".concat((0, Formatting_1.formatPrice)(price), "/").concat(productPackaging.masterUnit.toLowerCase());
};
exports.getProductPackagingPriceByWeight = getProductPackagingPriceByWeight;
exports.default = { getProductPackagingWeight: exports.getProductPackagingWeight, getProductPackagingMinimalWeight: exports.getProductPackagingMinimalWeight, getProductPackagingPriceByWeight: exports.getProductPackagingPriceByWeight };
//# sourceMappingURL=ProductPackaging.js.map